<template>
  <h3 class="text-lg font-medium">
    <slot />
  </h3>
</template>

<script setup lang="ts"></script>
